import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-active',
    templateUrl: './active.component.svg',
    styleUrls: ['./active.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveComponent {}
